module.exports = __webpack_public_path__ + "static/media/puretech.73bb4faf.jpg";